module.exports = __webpack_public_path__ + "static/media/october2024-1.c2133ed9.webp";